/**
 * Подписи дней на графиках по дням: «Обзор» и «Отчёты».
 */

/**
 * Через сколько столбцов подписывать дату.
 *
 * Семь дней подписываются все, тридцать — каждый третий, девяносто — каждый
 * десятый. Числа подобраны так, чтобы подписи не наезжали друг на друга
 * на узком экране: бэк-офис открывают и с телефона.
 */
export const tickStep = (length: number): number => (length <= 10 ? 1 : length <= 31 ? 3 : 10)

/** `2026-08-27` → `27.08`. Год в подписи столбца не нужен: период короче года. */
export function formatDay(iso: string): string {
  const [, month, day] = iso.split('-')
  return `${day ?? ''}.${month ?? ''}`
}
